import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, commsHeader, indianProjectsBaseURL } from '../../../../Containers/Config/index.js';
import {
  GET_COMS_CHANNEL_CONFIG_PROJECT,
  GET_COMS_CHANNEL_CONFIG_PROJECT_SUCCESS,
  GET_COMS_CHANNEL_CONFIG_PROJECT_ERROR,
} from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getComsChannelConfig({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${indianProjectsBaseURL}/comms/projects/channel/details`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
        ...commsHeader,
      },
      params: {
        ...payload?.urlParam,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMS_CHANNEL_CONFIG_PROJECT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMS_CHANNEL_CONFIG_PROJECT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMS_CHANNEL_CONFIG_PROJECT_ERROR, payload: error });
  }
}

export function* watchComsChannelConfig() {
  yield takeEvery(GET_COMS_CHANNEL_CONFIG_PROJECT, getComsChannelConfig);
}

function* getComsChannelConfigSaga() {
  yield all([fork(watchComsChannelConfig)]);
}

export default getComsChannelConfigSaga;
